export default "__VITE_ASSET__DfZSZ$MR__"